<template>
  <div class="wrap">
    <div class="apply-entry">
      <el-row justify="start">
        <el-col :md="18" :sm="18" :xs="18">
          <div class="apply-content">
            <img
              class="apply-icon hidden-xs-only"
              src="@/assets/images/icon/ic_apply.png"
              alt=""
            />
            <div class="apply-invite">
              <h2>提交申请，文都期待您的加入</h2>
              <p>
                你还可以拨打一对一合作热线
                <span class="apply-tel">15600128367</span>
              </p>
            </div>
          </div>
        </el-col>
        <el-col :md="6" :sm="6" :xs="6" class="apply-flex">
          <div class="cautious-text">投资需谨慎</div>
          <div class="apply-right">
            <router-link :to="{ path: '/apply' }" target="_blank"
              ><span class="entry-btn">立即申请</span></router-link
            >
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script >
import { defineComponent, ref } from "vue";
export default defineComponent({
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped type="text/scss">
.apply-entry {
  position: relative;
  padding: 40px;
  background: #fff;
  margin-top: -64px;
  z-index: 3;

  .apply-icon {
    float: left;
    width: 80px;
    height: 80px;
    margin-right: 24px;
  }
  .apply-invite {
    float: left;
    font-size: 14px;
    color: #869099;
    h2 {
      padding: 8px 0;
      font-size: 24px;
      color: #1b1d1f;
    }
    .apply-tel {
      color: #0099ff;
    }
  }
  .apply-flex {
    display: flex;
    align-items: center;
    justify-content: flex-end;
     margin-top: 16px;
    .cautious-text {
        margin-right: 20px;
      font-size: 18px;
      color: #0099ff;
      font-weight: 600;
    }
    .apply-right {
  
      overflow: hidden;
    }
    .entry-btn {
      float: right;
      display: block;
      width: 88px;
      height: 48px;
      background: #0099ff;
      border-radius: 24px;
      line-height: 48px;
      color: #fff;
      text-align: center;
      font-weight: bold;
     
    }
  }
}
</style>
